<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>工单分配至相应承办单位
        </div>
        <div class="workordr_content workordr_GDYQ">
            <el-form
                     :model="ruleForm"
                     label-position="left"
                     ref="ruleFormRef"
            >
                <div class="workordr_content_title">
                    <div class="workordr_content_title_left">
                        <span></span>
                        <p>承办单位</p>
                    </div>
                </div>
                <div style="background-color: white;padding: 0 12px 12px;">
                    <div class="workordrAssign_unit">
                        <div class="workordrAssign_unit_list" v-for="item in cbUnit" :key="item.czFpcbdwmc" s>
                            <div class="workordrAssign_unit_lable">
                                承办单位
                            </div>
                            <div class="workordrAssign_unit_name">
                                {{item.czFpcbdwmc}}
                            </div>
                            <div class="workordrAssign_unit_mainBtn active" v-if="item.czSfcz == 1">
                                主责
                            </div>
                        </div>
                    </div>
                    <el-form-item label="承办单位截止日期">
                        <el-date-picker
                            type="datetime"
                            placeholder="选择日期"
                            v-model="ruleForm.czFpdxjzrq"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="指挥中心处理意见"
                                  prop="czCzjgwb"
                                  :rules="{
                                    required: true,
                                    message: '请输入指挥中心处理意见',
                                    trigger: 'blur',
                                  }">
                        <el-input maxlength="2000" v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" show-word-limit type="textarea"/>
                    </el-form-item>
                    <!--<Workorder_file @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>-->
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, watch} from 'vue';
    import {dateFormat} from '../../assets/js/base.js';
    import {useStore} from 'vuex';
    import Workorder_file from './Wordorder_file.vue';
    import {ElMessageBox,ElLoading} from 'element-plus'
    export default {
        name: "WorkorderGDFP",
        props: ["gdId","timeCzJz"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleForm = reactive({
                "czCzlx": "GDYQ",
                "gdId": props.gdId,
                "czFpclsxzrr": "",
                "czFpdxjzrq": "",
                "czCzjgwb": "",
                fileIds:[],
            });
            const addHoldUnit = () => {
                ruleForm.userCodes.push(
                    {
                        "assignee": "",//被分配人ID
                        "type": false,//是否主责
                    }
                );
            }
            const reduceHoldUnit = (param) => {
                ruleForm.userCodes.splice(param, 1);
            }
            const ruleFormRef = ref()

            const mainResponsibilityChange = (key, index) => {
                if (ruleForm[key][index].type) {
                    ruleForm[key][index].type = false;
                } else {
                    ruleForm[key].map((x) => {
                        return x.type = false
                    });
                    ruleForm[key][index].type = true;
                }

            }
            const getCheckedNodes = (param) => {
                console.log(ruleForm)

            }
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess=true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            let clsxHourDisable = ref(false);//处理时限小时
            let clsxDayDisable = ref(false);//处理时限自然日
            const clsxHourInput = (param) => {
                if (param) {
                    ruleForm.clsx = +param;
                    clsxDayDisable.value = true;
                    clsxHourDisable.value = false;
                    var nowDate = new Date();
                    nowDate.setHours(nowDate.getHours() + Number(param))
                    ruleForm.czFpdxjzrq = dateFormat(nowDate)
                } else {
                    ruleForm.clsx = "";
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                }
            };
            const clsxDayInput = (param) => {
                if (param) {
                    ruleForm.clsx = +param;
                    clsxDayDisable.value = false;
                    clsxHourDisable.value = true;
                    var nowDate = new Date();
                    nowDate.setDate(nowDate.getDate() + Number(param));
                    ruleForm.czFpdxjzrq = dateFormat(nowDate);
                } else {
                    ruleForm.clsx = "";
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                }
            }
            let cbUnit = ref([]);
            //被选中的承办单位
            let selectedUserCodes = ref([])
            //递归所有的承办单位
            const dgArray = (param) => {
                for (let i in param) {
                    if (selectedUserCodes.value.indexOf(param[i].value) > -1) {
                        param[i].disabled = true;
                    } else {
                        param[i].disabled = false;
                    }
                    if (param[i].children && param[i].children.length > 0) {
                        dgArray(param[i].children)
                    }
                }
            }
            watch(() => ruleForm.userCodes, (newVal) => {
                selectedUserCodes.value = [];
                for (let i in newVal) {
                    if (newVal[i].assignee) {
                        selectedUserCodes.value.push(newVal[i].assignee)
                    }
                }
                dgArray(cbUnit.value)
            }, {deep: true})

            onMounted(() => {
                proxy.$axios.post("/jgfast/wgsj/getJxzfpxx",{
                    "gdId":props.gdId,
                }).then((res) => {
                    cbUnit.value = res.data.cbdw;
                    ruleForm.czFpdxjzrq = res.data.czFpdxjzrq;
                    ruleForm.czCzjgwb = res.data.czCzjgwb;
                });
            })
            //取消事件
            const cancleClick=()=>{
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                addHoldUnit,
                reduceHoldUnit,
                ruleFormRef,
                ruleForm,
                submitForm,
                mainResponsibilityChange,
                clsxHourDisable,
                clsxDayDisable,
                clsxHourInput,
                clsxDayInput,
                cbUnit,
                getCheckedNodes,
                cancleClick,
                fileListToParent,
                deleteFile
            }
        }
    }
</script>

<style scoped>
    .workordrAssign_unit_mainBtn{
        width: 40px !important;
        height: 18px !important;
        line-height: 18px !important;
        font-style: normal !important;
        font-weight: 700 !important;
        font-size: 12px !important;
    }
</style>
